<script setup lang="ts">
import { computed } from "vue";

import SVGWrapper from "./utils/SVGWrapper.vue";

import type { colorTag } from "@/Modules/App/Models/Styles/Colors";
import type { iconSize } from "@/Modules/App/Models/Styles/Icons";

export interface IconProps {
  size?: iconSize;
  color?: colorTag;
  background?: colorTag;
}

const props = withDefaults(defineProps<IconProps>(), { color: "content-high", size: "md" });

const colorClass = computed((): string => `fill-${props.color}`);
</script>

<template>
  <SVGWrapper :size="size" :background="background" viewBox="0 0 23 21">
    <g clip-path="url(#clip0_6892_9047)">
      <path
        d="M1.05283 6.82603H5.78283V21H1.05283V6.82603ZM3.44533 0C1.83658 0 0.777832 1.05755 0.777832 2.44474C0.777832 3.83192 1.79533 4.88947 3.39033 4.88947H3.41783C5.06783 4.88947 6.09908 3.80445 6.08533 2.44474C6.05783 1.05755 5.05408 0 3.44533 0ZM17.3466 6.4964C14.8303 6.4964 13.7166 7.86985 13.0978 8.845V6.82603H8.38158C8.38158 6.82603 8.43658 8.15827 8.38158 21H13.0978V13.0889C13.0978 12.6632 13.1391 12.2511 13.2491 11.9353C13.5928 11.0974 14.3628 10.2184 15.6691 10.2184C17.3741 10.2184 18.0616 11.5232 18.0616 13.4186V21H22.7778V12.8692C22.7778 8.51537 20.4541 6.48267 17.3466 6.48267V6.4964Z"
        :class="colorClass"
      />
    </g>
    <defs>
      <clipPath id="clip0_6892_9047">
        <rect width="22" height="21" fill="white" transform="translate(0.777832)" />
      </clipPath>
    </defs>
  </SVGWrapper>
</template>

<style scoped lang="scss"></style>
